import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table
} from 'reactstrap';
import numToWords from 'num-to-words';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
const GLOBAL = require('../../Globals');

class ViewTransfer extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			id: '',
			url: '',
			_message: '',
			value: '',
			alertClass: '',
			_redirect: false,
			posts: [],
		}
		this.onBack = this.onBack.bind(this);
		this.printDocument = this.printDocument.bind(this);
	}

	printDocument() {

		/* const input = document.getElementById('print-trans');
		html2canvas(input)
		  .then((canvas) => {
			const imgData = canvas.toDataURL('image/png');
			const pdf = new jsPDF('p', 'cm', 'legal');
			pdf.addImage(imgData, 'JPEG', 0, 0);
			//pdf.output('dataurlnewwindow');
			pdf.save("download.pdf");
		  }); */

		var content = document.getElementById("print-trans");
		var pri = document.getElementById("print_frame").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}

	onBack(e) {

		this.setState({ _redirect: true });
	}

	componentWillMount() {

		this.getdata();
	}

	getdata() {
		$("#showLoader").show();
		GetData('certificate/gettransferbyregno/' + this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if (res) {
				this.setState({
					ac: res[0]['academicyear'],
					name: res[0]['studentname'],
					cls: res[0]['admissionclass'],
					dob: res[0]['dob'],
					gender: res[0]['gender'],
					communi: res[0]['community'],
					caste: res[0]['caste'],
					nation: res[0]['nationality'],
					admissionno: res[0]['admissionno'],
					admissiondate: res[0]['admissiondate'],
					father: res[0]['fathername'],
					religion: res[0]['religion'],
					nationality: res[0]['nationality'],
					identify1: res[0]['identify1'],
					identify2: res[0]['identify2'],
					studcharacter: res[0]['studcharacter'],
					study: res[0]['study'],
					leaveclass: res[0]['leaveclass'],
					course: res[0]['course'],
					part1: res[0]['part1'],
					part3: res[0]['part3'],
					medium: res[0]['medium'],
					promo: res[0]['promo'],
					scholar: res[0]['scholarship'],
					medical: res[0]['medical'],
					msheetno: res[0]['marksheetno'],
					register: res[0]['register'],
					tmrcode: res[0]['tmrcode'],
					applicationdate: res[0]['applicationdate'],
					leftdate: res[0]['leftdate'],
					issuedate: res[0]['issuedate']
				});
			}
		});
	}

	getdob(dob) {

		var emptydob = '';
		if (dob != '0000-00-00') {
			var ed = new Date(dob);
			var edate = ed.setDate(ed.getDate() - 1);

			var d = new Date(edate),
				month = '' + (d.getMonth() + 1),
				day = '' + (d.getDate() + 1),
				year = d.getFullYear();

			if (month.length < 2) month = '0' + month;
			if (day.length < 2) day = '0' + day;

			return [day, month, year].join('-');
		}
		else {

			return emptydob;
		}
	}

	numtowrd(dob) {

		const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

		var emptydob = '';
		if (dob != '0000-00-00') {
			var ed = new Date(dob);
			var edate = ed.setDate(ed.getDate() - 1);

			var d = new Date(edate),
				month = '' + (d.getMonth() + 1),
				day = '' + (d.getDate() + 1),
				year = d.getFullYear();

			if (month.length < 2) month = '0' + month;
			if (day.length < 2) day = '0' + day;

			var da = numToWords(day);
			var mon = monthNames[d.getMonth()];
			var yea = numToWords(year);

			return [da, mon, yea].join(' - ');
		}
		else {

			return emptydob;
		}
	}

	render() {

		this.state.id = this.props.match.params.id;

		if (this.state._redirect) {

			return (<Redirect to={'/academic/certificate/edittransfer/' + this.state.id} />);

		}

		if (this.state.communi == 'SC' || this.state.communi == 'ST') {

			this.state.sccast = 'Yes';
			this.state.bccast = '----';
			this.state.mbccast = '----';
			this.state.scchrist = '----';
			this.state.dccast = '----';
			this.state.others = '----';
		}
		if (this.state.communi == 'BC' || this.state.communi == 'BCM') {

			this.state.bccast = 'Yes';
			this.state.mbccast = '----';
			this.state.scchrist = '----';
			this.state.sccast = '----';
			this.state.dccast = '----';
			this.state.others = '----';
		}
		if (this.state.communi == 'MBC') {

			this.state.mbccast = 'Yes';
			this.state.bccast = '----';
			this.state.sccast = '----';
			this.state.scchrist = '----';
			this.state.dccast = '----';
			this.state.others = '----';
		}
		if (this.state.communi == 'DNC') {

			this.state.mbccast = '----';
			this.state.bccast = '----';
			this.state.sccast = '----';
			this.state.scchrist = '----';
			this.state.dccast = 'Yes';
			this.state.others = '----';
		}
		if (this.state.communi == 'OC') {

			this.state.mbccast = '----';
			this.state.bccast = '----';
			this.state.sccast = '----';
			this.state.scchrist = '----';
			this.state.dccast = '----';
			this.state.others = 'Yes';
		}

		if (this.state.scholar == '') {

			this.state.scholar = 'NIL';
		}

		if (this.state.medical == '') {

			this.state.medical = 'NIL';
		}

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Transfer Certificate</strong>
									<Button outline color="primary" className="btn-right" onClick={this.onBack}>Edit</Button>
									<a target="_blank" href={GLOBAL.BASE_URL + 'certificate/printtransfer/' + this.state.id} className="btn btn-warning btn-right"><i className="fa fa-print"></i> Download Pdf</a>
								</CardHeader>
								<CardBody id="print-trans">
									<Row>
										<Col md="10 offset-1">
											<Card>
												<table>
													<tbody>
														<tr>
															<td rowSpan="4" width="80" align="right" style={{ paddingLeft: '90px' }}><img src={GLOBAL.BASE_URL + 'public/sclogo/logo.jpg'} width="70" /></td>
														</tr>
														<tr>
															<td align="left" className="ctext">{GLOBAL.Sclful_NAME}</td>
														</tr>
														<tr>
															<td align="left" className="caddrtext">{GLOBAL.Scl_Addr}</td>
														</tr>
														<tr>
															<td align="left" className="caddrtext">{GLOBAL.Scl_Dist}</td>
														</tr>
													</tbody>
												</table>
												<hr className="line-margin"></hr>
												<table>
													<tbody>
														<tr>
															<td align="center"><u className="tctext">TRANSFER CERTIFICATE</u><p style={{ position: 'absolute', right: '20px', top: '85px' }}><b>Admission No : {this.state.admissionno}</b></p></td>
														</tr>
													</tbody>
												</table>
												<table className="tab-marginr">
													<tbody>
														<tr>
															<td width="350">1.	Name of the Pupil</td>
															<td> : </td>
															<td>{this.state.name} </td>
														</tr>
														<tr>
															<td>2.	Name of the Father or Mother </td>
															<td> : </td>
															<td>{this.state.father} </td>
														</tr>
														<tr>
															<td>3.	Nationality and Religion </td>
															<td> : </td>
															<td id="teatext">{this.state.nation} - {this.state.religion} </td>
														</tr>
														<tr>
															<td>4.	Community, whether he/she belongs to </td>
															<td> : </td>
															<td></td>
														</tr>
													</tbody>
												</table>
												<table className="tab-marginr">
													<tbody>
														<tr>
															<td className="table-border" align="center"><b>Scheduled Caste/Scheduled Tribe</b></td>
															<td className="table-border" align="center"><b>Backward Class</b></td>
															<td className="table-border" align="center"><b>Most Backward Class</b></td>
															<td className="table-border" align="center"><b>Convert  to Christianity from SC</b></td>
															<td className="table-border" align="center"><b>Denotified Communities</b></td>
															<td className="table-border" align="center"><b>Others</b></td>
														</tr>
														<tr>
															<td className="table-border" align="center">{this.state.sccast}</td>
															<td className="table-border" align="center">{this.state.bccast}</td>
															<td className="table-border" align="center">{this.state.mbccast}</td>
															<td className="table-border" align="center">{this.state.scchrist}</td>
															<td className="table-border" align="center">{this.state.dccast}</td>
															<td className="table-border" align="center">{this.state.others}</td>
														</tr>
													</tbody>
												</table>
												<table className="tab-marginr">
													<tbody>
														<tr>
															<td width="350">5.	Caste </td>
															<td> : </td>
															<td id="teatext">{this.state.caste} </td>
														</tr>
														<tr>
															<td>6.	Sex </td>
															<td> : </td>
															<td>{this.state.gender}</td>
														</tr>
														<tr>
															<td>7.	Date of Birth as per school record (In words) </td>
															<td> : </td>
															<td className="txt-capital">{this.getdob(this.state.dob)}<br></br>({this.numtowrd(this.state.dob)})</td>
														</tr>
														<tr>
															<td>8.	Personal marks of identification </td>
															<td> : </td>
															<td></td>
														</tr>
														<tr>
															<td className="identify">
																(a) {this.state.identify1}
															</td>
															<td></td>
															<td></td>
														</tr>
														<tr>
															<td className="identify">
																(b) {this.state.identify2}
															</td>
															<td></td>
															<td></td>
														</tr>
														<tr>
															<td>9.	Date of admission and Standard </td>
															<td> : </td>
															<td>{this.getdob(this.state.admissiondate)} - {this.state.cls}</td>
														</tr>
														<tr>
															<td>10.	Standard in which the pupil was studying<br></br>At the time of leaving (in words) </td>
															<td> : </td>
															<td>{this.state.leaveclass}</td>
														</tr>
													</tbody>
												</table>
												<table className="tab-marginr">
													<tbody>
														<tr>
															<td className="table-border" align="center"><b>The course offered i.e General<br></br>or Vocational Education</b></td>
															<td className="table-border" align="center"><b>Subjects offered under part III</b></td>
															<td className="table-border" align="center"><b>Language offered Under Part I</b></td>
															<td className="table-border" align="center"><b>Medium of study</b></td>
														</tr>
														<tr>
															<td className="table-border" align="center">{this.state.course}</td>
															<td className="table-border" align="center">{this.state.part3}</td>
															<td className="table-border" align="center">{this.state.part1}</td>
															<td className="table-border" align="center">{this.state.medium}</td>
														</tr>
													</tbody>
												</table>
												<table className="tab-marginr">
													<tbody>
														<tr>
															<td width="350">11.	Wheyther qualified for promotion to Higher standard </td>
															<td> : </td>
															<td>{this.state.promo}</td>
														</tr>
														<tr>
															<td>12.	Whether the pupil was in receipt of any	Scholarship </td>
															<td> : </td>
															<td>{this.state.scholar}</td>
														</tr>
														<tr>
															<td>13.	Whether the pupil has undergone medical Inspection </td>
															<td> : </td>
															<td>{this.state.medical}</td>
														</tr>
														<tr>
															<td>14.	Date on which the pupil actually left </td>
															<td> : </td>
															<td>{this.getdob(this.state.leftdate)}</td>
														</tr>
														<tr>
															<td>15.	The pupil’s conduct and character </td>
															<td> : </td>
															<td>{this.state.studcharacter}</td>
														</tr>
														<tr>
															<td>16.	Date on which application for Transfer Certificate was made on behalf of the Pupil by the parent or guardian </td>
															<td> : </td>
															<td>{this.getdob(this.state.applicationdate)}</td>
														</tr>
														<tr>
															<td>17.	Date of issuing the Transfer Certificate </td>
															<td> : </td>
															<td>{this.getdob(this.state.issuedate)}</td>
														</tr>
														<tr>
															<td>18.	Course Study </td>
															<td> : </td>
															<td></td>
														</tr>
													</tbody>
												</table>
												<table className="tab-marginr">
													<tbody>
														<tr>
															<td className="table-border" align="center"><b>Name of the School</b></td>
															<td className="table-border" align="center"><b>Academic Year</b></td>
															<td className="table-border" align="center"><b>Standard(s) Studied</b></td>
															<td className="table-border" align="center"><b>First Language</b></td>
															<td className="table-border" align="center"><b>Medium of Instruction</b></td>
														</tr>
														<tr>
															<td className="table-border" id="teatext" align="center">{GLOBAL.Sclful_NAME}</td>
															<td className="table-border" align="center">{this.state.ac}</td>
															<td className="table-border" align="center">{this.state.study}</td>
															<td className="table-border" align="center">TAMIL</td>
															<td className="table-border" align="center">ENGLISH</td>
														</tr>
													</tbody>
												</table>
												<br></br>
												<table className="tab-marginr">
													<tbody>
														<tr>
															<td className="table-border" align="center"><b>Mark Sheet SI.No</b></td>
															<td className="table-border" align="center"><b>REGISTER NO</b></td>
															<td className="table-border" align="center"><b>TMR CODE</b></td>
														</tr>
														<tr>
															<td className="table-border" align="center">{this.state.msheetno}</td>
															<td className="table-border" align="center">{this.state.register}</td>
															<td className="table-border" align="center">{this.state.tmrcode}</td>
														</tr>
													</tbody>
												</table>
												<br></br>
												<table className="tab-marginr">
													<tbody>
														<tr>
															<td>School Seal</td>
															<td align="right">Signature of the Principal/Headmistress with Seal</td>
														</tr>
													</tbody>
												</table>
												<br></br>
												<br></br>
												<table className="tab-marginr">
													<tbody>
														<tr>
															<td>N.B &nbsp;&nbsp; 1. Erasure and unauthenticated or fraduient alternations in the certificate will lead to its cancellation.</td>
														</tr>
														<tr>
															<td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. Should be signed in ink by the Head of the Institution, who will be held responsible of the correctness of the entries.</td>
														</tr>
													</tbody>
												</table>
												<table className="tab-marginr">
													<tbody>
														<tr>
															<td align="center"><b><u>Declaration by the Parent / Guardian</u></b></td>
														</tr>
														<tr>
															<td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I hereby declare that the particulars recorded against items 1 to 7 are correct and that no change will demanded by me in future.</td>
														</tr>
														<tr><td align="right">Signature of the Parent / Guardian</td></tr>
													</tbody>
												</table>
											</Card>
										</Col>
									</Row>
								</CardBody>
								<iframe name="print_frame" id="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default ViewTransfer;


// WEBPACK FOOTER //
// ./src/certificate/Transfer/ViewTransfer.js